// linkEmbedNode.js
// Inline feature: block-level rich link preview node

export const linkEmbedNode = {
    group: "block",
    atom: true,
    selectable: true,
    draggable: true,
    attrs: {
        url: {},
        title: {default: null},
        description: {default: null},
        siteName: {default: null},
    },
    parseDOM: [{
        tag: "div[data-type='link-embed']",
        getAttrs(dom) {
            return {
                url: dom.getAttribute("data-url"),
                title: dom.getAttribute("data-title"),
                description: dom.getAttribute("data-description"),
                siteName: dom.getAttribute("data-site-name"),
            };
        },
    }],
    toDOM(node) {
        const attrs = {
            "data-type": "link-embed",
            "data-url": node.attrs.url,
            class: "pm-link-embed",
        };
        if (node.attrs.title) attrs["data-title"] = node.attrs.title;
        if (node.attrs.description) attrs["data-description"] = node.attrs.description;
        if (node.attrs.siteName) attrs["data-site-name"] = node.attrs.siteName;
        return ["div", attrs];
    },
};

